import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { disableLoadingSpinner, enableLoadingSpinner } from "app/loading.slice";
import { AppDispatch } from "app/store";

export const useLoading = () => {
  const dispatch = useDispatch<AppDispatch>();

  const showLoadingSpinner = useCallback(
    (newText: string) => {
      dispatch(enableLoadingSpinner(newText));
    },
    [dispatch],
  );

  const hideLoadingSpinner = useCallback(() => {
    dispatch(disableLoadingSpinner());
  }, [dispatch]);

  return { showLoadingSpinner, hideLoadingSpinner };
};
